
const network = require('./net.config')
const setting = require('./setting.config')
module.exports = { network, setting }